module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp3_8003.78c9d248.png";